/* eslint-disable no-nested-ternary */
import React, {
  Fragment,
  useState,
  useContext,
  useRef,
  useEffect,
} from 'react';
import ReactQuill from 'react-quill';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { PRNRoles } from '@mummssoftware/utils/constants';
import {
  PSOMenuDiv,
  PSOEditor,
  PRNDiv,
} from '../../components/layout/WrapperDiv';
import { ProgressNotesContext } from '../Context/ProgressNotesContext';
import {
  SET_PSO_TEXT,
  SET_PRN_PERMISSION,
  PRNPermissionsVisit,
} from '../Context/constants';
import { modules, formats } from './constants';
import defaults from '../../translations/en.json';

import 'react-quill/dist/quill.snow.css';
import './style/style.css';

const useStyles = makeStyles((theme) => ({
  root: {
    color: `${(theme as any).palette.primary.main}`,
  },
  checked: {
    color: `${(theme as any).palette.primary.main}`,
    '&$checked': {
      color: `${(theme as any).palette.primary.main}`,
    },
  },
  label: {
    fontSize: '1rem',
  },
}));

type PSOMenuProps = {
  standingOrders: mumms.StandingOrder;
};

const PSOMenu = ({ standingOrders }: PSOMenuProps) => {
  const { psoText, dispatch } = useContext(ProgressNotesContext);

  const reactQuillRef: any = useRef<HTMLDivElement | null>();
  const classes = useStyles();

  const checkedInitState: PRNPermissionsVisit = PRNRoles.reduce(
    (seed: any, val: any) => {
      if (val.key) {
        seed[val.key] = !!(
          (standingOrders as any)[val.key] &&
          (standingOrders as any)[val.key] === 'true'
        );
      }
      return seed;
    },
    {} as any,
  );

  // On Load
  useEffect(() => {
    dispatch({
      type: SET_PRN_PERMISSION,
      payload: checkedInitState,
    });
  }, []);

  const [checkedState, setCheckedState] = useState<any>(checkedInitState);

  const handlePRNChange = (event: any) => {
    const targetName = event.target.name;
    const newPRNState = {
      ...checkedState,
      [targetName]: !checkedState[targetName],
    };
    setCheckedState(newPRNState);
    dispatch({
      type: SET_PRN_PERMISSION,
      payload: newPRNState,
    });
  };

  const handleChange = (html: any) => {
    dispatch({
      type: SET_PSO_TEXT,
      payload: html,
    });

    // @note for use later
    // if (reactQuillRef.current) {
    //   const editor = reactQuillRef.current.getEditor();
    //   const unprivilegedEditor = reactQuillRef.current.makeUnprivilegedEditor(
    //     editor,
    //   );
    //   console.log('getText', unprivilegedEditor.getText());
    // }
  };

  const getPRNBoxes = () => (
    <Fragment>
      <div>{defaults.prnOrder}</div>
      <PRNDiv>
        {PRNRoles.map((role: mumms.PRNRole) => (
          <FormControlLabel
            control={
              <Checkbox
                checked={checkedState[role.key]}
                onChange={handlePRNChange}
                name={role.key}
                classes={{ root: classes.root, checked: classes.checked }}
              />
            }
            label={role.name}
            key={role.key}
            classes={{
              label: classes.label,
            }}
          />
        ))}
      </PRNDiv>
    </Fragment>
  );

  const getMenuContent = () => (
    <PSOMenuDiv>
      {getPRNBoxes()}
      <PSOEditor className="pso_editor">
        <ReactQuill
          theme="snow"
          onChange={handleChange}
          value={psoText}
          modules={modules}
          formats={formats}
          placeholder="type something"
          ref={reactQuillRef}
        />
      </PSOEditor>
    </PSOMenuDiv>
  );

  return <Fragment>{getMenuContent()}</Fragment>;
};

export default PSOMenu;
